export const STRING_BRAND_CODE = "BRAND00110";

export const VIDEO_POSITION = 2;

export const FREE_SHIPPING_USP_ID = "17QcX4I20l9IBbKzNyrQQY";
export const RETURN_USP_ID = "25O3y4al4oaGTkpslLMLdJ";

export const ACCESSORIES_KEY = "Tillbehör";
export const LIGHTSOURCES_KEY = "Ljuskälla";
export const RECOMMENDED_KEY = "Rekommenderad ljuskälla";
export const SAMPLES_KEY = "sample_use";
export const STRUCTURED_ITEMS_KEY = "structureItems";

export const SELECTABLE_STOCK_STATUSES = [1, 2, 3, 4, 5, 6, 7];

export const STOCK_STATUS_PRIORITY: Record<string, number> = {
  Unknown: 0,
  StockItem: 1,
  PendingOutOfStock: 2,
  PendingSoldOut: 3,
  Incoming: 4,
  DeliveryItem: 5,
  OutOfStock: 6,
  SoldOut: 7,
  Hidden: 8,
};

export const OVERSELLABLE_STATUSES = ["backorder_item"];

export const MONITOR_STOCK_STATUSES = ["SoldOut", "OutOfStock", "Unknown"];

export enum RetailStoreCode {
  Stockholm = "46001",
  Gothenburg = "46005",
  Malmo = "46004",
  Oslo = "47001",
}

export const CALL_FOR_STOCK_STORE_CODE = "call";

/** Order of the stores in the store flyout. Stores not listed go last. */
export const STORE_ORDER: string[] = [
  RetailStoreCode.Stockholm,
  RetailStoreCode.Malmo,
  RetailStoreCode.Gothenburg,
  CALL_FOR_STOCK_STORE_CODE,
];

export enum RetailStorePrefix {
  Display = "DR",
  Store = "SR",
}
